import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting";

export default {
  getSageSupplierType(id) {
    return Repository.get(`${resource}/sage_supplier_types/${id}`)
  },
  getListOfSageSupplierTypes(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/sage_supplier_types?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getListOfSageSupplierTypeNoPagination(filterQuery) {
    return Repository.get(`${resource}/sage_supplier_types?is_paginate=0&${filterQuery}`)
  },
  createSageSupplierType(payload) {
    return Repository.post(`${resource}/sage_supplier_types`, payload)
  },
  deleteSageSupplierType(id) {
    return Repository.delete(`${resource}/sage_supplier_types/${id}`)
  },
  updateSageSupplierType(id, payload) {
    return Repository.put(`${resource}/sage_supplier_types/${id}`, payload)
  }
};
